import {
  HttpError,
  type GetListParams,
  type QueryFunctionContext,
} from "react-admin";

import { createApiClient } from "@/api";
import { HTTP_STATUS } from "@/constants/http";
import { type DataProviderSchema } from "@/utils";

const apiClient = createApiClient("jsonld");
const BASE_URL = "/api/vpn/mail_subjects";

const fetchListData = async ({
  pagination,
}: GetListParams & QueryFunctionContext) => {
  const response = await apiClient.GET(BASE_URL, {
    params: {
      query: {
        pagination: true,
        limit: pagination?.perPage,
        page: pagination?.page,
      },
    },
  });

  const data = response.data?.["hydra:member"] ?? [];

  return {
    data,
    total: response.data?.["hydra:totalItems"] ?? 0,
  };
};

export const mailSubjectsSchema: DataProviderSchema<"MailSubject", "jsonld"> = {
  list: fetchListData,
  detail: async ({ id }) => {
    const { data } = await apiClient.GET(`${BASE_URL}/{id}`, {
      params: {
        path: { id: String(id) },
      },
    });

    if (!data) throw new Error("Mail subject not found");

    return { data };
  },
  create: async ({
    data: { clientApp = "", title = "", type = "", body = "" },
  }) => {
    const response = await apiClient.POST(BASE_URL, {
      body: {
        clientApp,
        title,
        type,
        body,
      },
    });

    if (!response.data)
      throw new HttpError(
        "Something went wrong!",
        HTTP_STATUS.INTERNAL_SERVER_ERROR,
      );

    return {
      data: response.data,
    };
  },
  edit: async ({
    id,
    data: { clientApp = "", title = "", type = "", body = "" },
  }) => {
    const response = await apiClient.PUT(`${BASE_URL}/{id}`, {
      params: {
        path: { id: String(id) },
      },
      body: {
        clientApp,
        title,
        type,
        body,
      },
    });

    if (!response.data)
      throw new HttpError(
        "Something went wrong!",
        HTTP_STATUS.INTERNAL_SERVER_ERROR,
      );

    return {
      data: response.data,
    };
  },
};
